<template>
    <div>
        <CCol sm="12" xs="6" class="text-right">
            <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                <span style="margin-top:20px">Tracking</span>
            </h5>
    
        </CCol>
        <div style="clear:both"></div>
        <CCol sm="12">
            <CCard style="border:none" class="b-20 mt-3">
                <CRow>
                    <div style="width:30%">
                        <div class="ml-4 mt-2">
                            <img style="width:60px" src="../assets/img/usercard1.png" />
                        </div>
                    </div>
                    <div style="width:70%">
                        <CRow class="p-2 mt-2">
                            <CCol sm="12">
                                <h3 class="custom-14px-700">
                                    Andrew Preston
                                </h3>
                            </CCol>
                            <div class="ml-2">
                                <label class="custom-12px mt-2">Cleaning Home</label>
                            </div>
                        </CRow>
                    </div>
                </CRow>
                <CCol sm="12">
                    <CRow>
    
                        <label class="mt-2 mr-4 ml-2">Status</label>
                        <CButton type="button" class="button-border-blue text-white">
                            On Process
                        </CButton>
                        <CCol sm="12">
                            <div class="p-2">
                                <CRow>
                                    <div style="width:20%">
                                        <img style="max-width:100%" src="../assets/img/track.png" /></div>
                                    <div style="width:80%">
                                        <h3 class="custom-14px-500 mt-2">Request Accepted</h3>
    
                                        <p class="custom-muted-text"> <img style="max-width:20px" src="../assets/img/time.png" /> 10:00 am • Jan 2th 2024</p>
                                        <h3 class="custom-14px-500 mt-5">Genie Helper Arrived</h3>
    
                                        <p class="custom-muted-text"> <img style="max-width:20px" src="../assets/img/time.png" /> 10:00 am • Jan 2th 2024</p>
                                        <br />
                                        <h3 class="custom-14px-500 mt-4">Cleaning</h3>
    
                                        <p class="custom-muted-text"> <img style="max-width:20px" src="../assets/img/time.png" /> 10:00 am • Jan 2th 2024</p>
    <br />
                                        <h3 class="custom-14px-500 mt-4">Finished</h3>
    
    <p class="custom-muted-text"> <img style="max-width:20px" src="../assets/img/time.png" /> 10:00 am • Jan 2th 2024</p>

                                    </div>
                                </CRow>
                            </div>
                        </CCol>
                    </CRow>
                </CCol>
            </CCard>
        </CCol>
    
        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/sendnoti.png" />
                    <h3 class="custom-18px-500 text-center">You Only able to choose one Genie Helper for One Job</h3>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToAnother()">Choose</CButton>
                </div>
            </div>
        </div>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all" @click="closePopup1">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/successright.png" />
                    <h3 class="custom-18px-500 text-center">You have accepted the Genie Helper</h3>
                    <CButton type="button" class="button-border-blue text-white mt-4" block>OK</CButton>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";

import backgroundUrl from "../assets/img/bgHomeUser.png";
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
export default ({
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        HooperPagination,
        MainlayoutBottom,
    },
    data() {
        return {
            isLanguagePopupVisible: false,
            isLanguagePopupVisible1: false,
            code: ["", "", "", ""],
            hooperSettings1: {
                hideArrows: true,
            },
            backgroundUrl

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToBooking() {
            this.$router.push("ProfileUser");
        },
        OpenPopup() {
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToAnother() {
            this.isLanguagePopupVisible1 = true;
            //this.isLanguagePopupVisible = false;

        },
        closePopup1() {
            this.isLanguagePopupVisible1 = false;
        },



    }
})
</script>

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>